<template>
  <div class="top-hero2">
    <div class="container">
      <div id="challange-target">hidden</div>

      <div class="marginTop d-flex justify-content-md-center">
        <v-app style="margin: 0; background-color: transparent; color: white">
          <v-container fill-height>
            <v-layout align-center>
              <v-flex>
                <h3 class="display-3">Welcome to Homes By 360</h3>

                <span class="subheading"
                  >Thanks for registering an account in HomesBy360! Before we
                  get started, we'll need to verify your email.</span
                >

                <v-divider class="my-3"></v-divider>
                <v-btn class="mx-0" color="primary" large>
                  Go Home
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-app>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  methods: {}
};
</script>
